export default __webpack_public_path__ + "static/Retul+fit_Performance_Web-960ff68cd4570e20d47520bfde03d551.jpg";